import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPartsWithFilters } from './store/slice';
import { fetchCustomers } from '../../core/redux/customer/slice';
import { fetchLocations } from '../../core/redux/location/slice';
import PartTopHead from './partmasters-top-head';
import PartContent from './partmasters-content';
import PartModals from './partmasters-modals';
import { actions as inventoryActions } from './store/slice';

const { resetFilters } = inventoryActions;

const PartView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchPartsWithFilters());
    dispatch(fetchCustomers());
    dispatch(fetchLocations({name:"",description:""}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => dispatch(resetFilters());
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Part</h4>
              </div>
            </div>
            <PartTopHead />
          </div>
          <PartContent />
          <PartModals />
        </div>
      </div>
    </div>
  );
};

export default PartView;
